<route>
{
  "meta": {
    "permission": [
      "base_config.view_productiondepartment"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <dial-department
      v-if="dialog"
      v-model="dialog"
      :to-edit="toEdit"
      :max="true"
      @done="reload = true"
    />
    <i-table
      app="base_config.productiondepartment"
      api="department"
      :headers="headers"
      :opt="{ company_id: company.pk }"
      :reload.sync="reload"
      :title="$t('department')"
      @click:create="open()"
      @click:edit="open($event)"
    >
      <template v-slot:item.description="{ item }">
        <span class="template-list" v-html="item.description"></span>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import dialDepartment from '@/components/department/modal.vue'
export default {
  components: {
    dialDepartment
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$t('description'),
          value: 'description'
        },
        {
          text: this.checkPermissions.editOrDelete ? this.$t('action') : '',
          value: this.checkPermissions.editOrDelete ? 'actions' : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    ...mapGetters({
      company: 'company/getCompanyData',
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @returns {Object} Objeto con los permisos del usuario.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        editOrDelete:
          this.getPermissions([`base_config.change_productiondepartment`]) ||
          this.getPermissions([`base_config.delete_productiondepartment`])
      }
    }
  },
  data() {
    return {
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
<style lang="sass">
.template-list > p
  margin-bottom: 0
  & + p
    margin-top: 4px
</style>
